import { actionsTypePolicies } from "./actions/useQueryActions"
import { areasTypePolicies } from "./areas/useQueryAreas"
import { assetsTypePolicies } from "./assets/useQueryAssets"
import { assetTypesTypePolicies } from "./assets/useQueryAssetTypes"
import { downloadsTypePolicies } from "./downloads/useQueryDownloads"
import { integrationQueryTypePolicies } from "./integrations/integrationQueryTypePolicies"
import { integrationSensorsTypePolicies } from "./sensors/useQueryIntegrationSensors"
import { jobsTypePolicies } from "./jobs/useQueryJobs"
import { jobStepTypePolicies } from "./jobs/useQueryJobStep"
import { notificationPostTypePolicies } from "./notifications/useQueryNotifications"
import { postsTypePolicies, postTypePolicies } from "./posts/useQueryPosts"
import { processesQueryTypePolicies, processTypePolicies } from "./processes/useQueryProcesses"
import { sensorTypePolicies } from "./sensors/useQuerySensor"
import { sensorsTypePolicies } from "./sensors/useQuerySensors"
import { sensorRuleTypePolicies } from "./sensors/useQuerySensorRules"
import { suppliersTypePolicies } from "./suppliers/useQuerySuppliers"
import { trainingCourseTypePolicies } from "./training/useQueryTrainingCourses"
import { adminableUsersQueryTypePolicies } from "./users/useQueryAdminableUsers"
import { userAccreditationTypePolicies } from "./users/useQueryUserAccreditations"
import { reportTrainingUsersQueryTypePolicies } from "./report/useQueryReportTrainingUsers"
import { loginResultTypePolicies } from "./users/fragments/loginFieldsFragment"
import { foodItemsPolicies } from "./food-items/useQueryFoodItems"
import { prepListsTypePolicies } from "./prep/useQueryPrepLists"
import { prepListTypePolicies } from "./prep/fragments/prepListFieldsFragment"
import { reportTypePolicies } from "./report/reportTypePolicies"
import { jobStepNoteTypePolicies } from "./jobs/useQueryJobNotes"
import { timersTypePolicies } from "./timers/useQueryTimers"
import { knowledgesTypePolicies } from "./knowledge/useQueryKnowledges"
import { customFieldTypePolicies } from "./customFields/useQueryCustomFields"
import { uploadTypePolicies } from "./upload/uploadTypePolicies"
import { timesheetsTypePolicies } from "./timesheets/useQueryTimesheetsList"
import { userTrainingCoursesTypePolicies } from "./training/useQueryUserTrainingCourses"
import { locationsTypePolicies } from "./locations/useQueryLocations"
import { workflowsTypePolicies } from "./workflow/useQueryWorkflows"
import { myCurrentlyAssignedWorkflowsTypePolicies } from "./workflow/useQueryCurrentlyAssignedWorkflows"
import { printersTypePolicies } from "./printers/useQueryPrinters"

const typePolicies = {
  Query: {
    fields: {
      ...adminableUsersQueryTypePolicies.root,
      ...jobsTypePolicies.root,
      ...loginResultTypePolicies.root,
      ...reportTrainingUsersQueryTypePolicies.root,
      ...prepListTypePolicies.root,
      ...sensorsTypePolicies.root,
      ...sensorTypePolicies.root,
      ...uploadTypePolicies.root
    }
  },
  ...actionsTypePolicies.scoped,
  ...areasTypePolicies.scoped,
  ...assetsTypePolicies.scoped,
  ...assetTypesTypePolicies.scoped,
  ...adminableUsersQueryTypePolicies.scoped,
  ...downloadsTypePolicies.scoped,
  ...foodItemsPolicies.scoped,
  ...processesQueryTypePolicies,
  ...integrationQueryTypePolicies,
  ...integrationSensorsTypePolicies.scoped,
  ...jobsTypePolicies.scoped,
  ...jobStepTypePolicies.scoped,
  ...jobStepNoteTypePolicies.scoped,
  ...locationsTypePolicies.scoped,
  ...loginResultTypePolicies.scoped,
  ...postTypePolicies,
  ...prepListsTypePolicies.scoped,
  ...printersTypePolicies.scoped,
  ...postsTypePolicies.scoped,
  ...processTypePolicies,
  ...notificationPostTypePolicies,
  ...sensorsTypePolicies.scoped,
  ...sensorTypePolicies.scoped,
  ...sensorRuleTypePolicies.scoped,
  ...suppliersTypePolicies.scoped,
  ...trainingCourseTypePolicies,
  ...userAccreditationTypePolicies,
  ...userTrainingCoursesTypePolicies.scoped,
  ...reportTrainingUsersQueryTypePolicies.scoped,
  ...prepListTypePolicies.scoped,
  ...reportTypePolicies.scoped,
  ...timersTypePolicies.scoped,
  ...timesheetsTypePolicies.scoped,
  ...knowledgesTypePolicies.scoped,
  ...customFieldTypePolicies.scoped,
  ...uploadTypePolicies.scoped,
  ...workflowsTypePolicies.scoped,
  ...myCurrentlyAssignedWorkflowsTypePolicies.scoped
}

export { typePolicies }
